export const GET_PERMISSIONS_REQUEST = 'GET_PERMISSIONS_REQUEST';
export const GET_VISIBILITY_CHECK_REQUEST = 'GET_VISIBILITY_CHECK_REQUEST';

export const getPermissions = (callback) => ({
    type: GET_PERMISSIONS_REQUEST,
    payload: { callback },
});

export const getVisibilityCheck = (payload, callback) => ({
    type: GET_VISIBILITY_CHECK_REQUEST,
    payload: { ...payload, callback },
});
